// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'holonetTheme',
    themes: {
      holonetTheme: {
        dark: true,
        colors: {
          background: '#0D1117', // Deep space background
          surface: '#1E1E2F', // Panel-like surface
          primary: '#008cff', // Jedi blue
          secondary: '#FFC710', // Tatooine sunset
          accent: '#FF4136', // Sith red
          success: '#4CAF50', // Lightsaber green
          warning: '#FFC107', // Cautionary yellow
          error: '#F44336', // Danger red
          info: '#2196F3', // Information blue
        },
      },
    },
  },
})